var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemovePhotoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Remove_Photo_Grey_18px",
    "data-name": "Remove Photo Grey_18px",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.07,
    height: 18,
    viewBox: "0 0 18.07 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_462",
    "data-name": "Rectangle 462",
    width: 18,
    height: 18,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1308",
    "data-name": "Group 1308",
    transform: "translate(-287.859 -4664.197)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1307",
    "data-name": "Group 1307",
    transform: "translate(298.641 4673.279)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_513",
    "data-name": "Path 513",
    d: "M70.538,67.269a3.269,3.269,0,1,0-3.269,3.269A3.27,3.27,0,0,0,70.538,67.269Z",
    transform: "translate(-64 -64)",
    fill: "none",
    stroke: "#a9a9a9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_514",
    "data-name": "Path 514",
    d: "M178.059,256H176",
    transform: "translate(-173.761 -252.731)",
    fill: "none",
    stroke: "#a9a9a9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Remove_Photo2-01",
    "data-name": "Remove Photo2-01",
    transform: "translate(288.859 4666.197)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_515",
    "data-name": "Path 515",
    d: "M10.222,5.458A3.059,3.059,0,0,1,7.558,8.615,2.96,2.96,0,0,1,4.4,5.951V5.458A3.059,3.059,0,0,1,7.064,2.3a3.059,3.059,0,0,1,3.158,2.664Z",
    transform: "translate(-0.993 -2.297)",
    fill: "none",
    stroke: "#a9a9a9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_521",
    "data-name": "Path 521",
    d: "M10.966,11.787a7.894,7.894,0,0,0-3.75-.987C4.354,10.8,1.493,12.379,1,15.339a.493.493,0,0,0,.3.691H13.038c.3-.1.493-.3.493-.493",
    transform: "translate(-0.948 -2.41)",
    fill: "none",
    stroke: "#a9a9a9",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemovePhotoIcon);
export default __webpack_public_path__ + "static/media/remove-photo-icon.fdf12b02cbb0d8220c4c369bcd58958d.svg";
export { ForwardRef as ReactComponent };